import { render, staticRenderFns } from "./CompareTotalPrimaryCell.vue?vue&type=template&id=555c108b&"
import script from "./CompareTotalPrimaryCell.vue?vue&type=script&lang=js&"
export * from "./CompareTotalPrimaryCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports